import { VehicleContext } from '@finn/ua-vehicle';
import { useContext } from 'react';

import { Equipment } from './Equipment';
import { EquipmentDetails } from './EquipmentDetails';

export const EquipmentDetailsComponent = ({
  productDetailsData,
}: {
  productDetailsData: any;
}) => {
  const { vehicle } = useContext(VehicleContext);

  const isCategoryCar = vehicle?.id?.startsWith('category-');
  if (isCategoryCar) {
    return null;
  }

  return (
    <div className="w-full grid-cols-1">
      <Equipment productDetailsData={productDetailsData} />
      <EquipmentDetails />
    </div>
  );
};
